<template>
  <form  action="javascript:void(0);" class="search-group">
        <img class="search-logo" src="../../assets/logo-icon.png">
        <input v-model="keyWord" class="search-input" type="search"
        	placeholder="请输入品名、货号、CAS号或关键字"  @keydown.enter="searchSub"
                ref="searchInput"><button class="search-btn"  @click="searchSub"></button>
    </form>
</template>

<script>
	export default {
    name: 'searchBlock',
    data () {
      return {
      	keyWord:''
      }
    },
		methods:{
			searchSub(){
				this.$emit('searchSub',this.keyWord);
			},
			setKeyword(keyword){
				this.keyWord=keyword;
			}
		}
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.search-group{
	display: flex;
	padding: .1rem;
	align-items: center;
	text-align: center;
	background-color: #fff;
	box-sizing: border-box;
	border-bottom: 1px solid #e5e5e5;
	.search-logo{
	    padding-right: .1rem;
	    width: .45rem;
	    height: .36rem;
	    box-sizing: border-box;
		}
	.search-input{
    flex: 1;
    display: inline-block;
    vertical-align:middle;
    line-height: .4rem;
    height: .4rem;
    border: 2px solid $mainColor;
    font-size: .13rem;
    color: #333;
    text-indent: .05rem;
    text-align: center;
    border-radius: .04rem 0 0 .04rem;
    -webkit-border-radius:  .04rem 0 0 .04rem;
	}
	.search-btn{
    display: inline-block;
    vertical-align:middle;
    padding: 0 .08rem;
    margin:0;
    height: .4rem;
    width: .36rem;
    color: #fff;
    border:none;
    border-radius: 0 .04rem .04rem 0;
    -webkit-border-radius: 0 .04rem .04rem 0;
    background: url(../../assets/search-icon-w.png) no-repeat center;
    background-size: .2rem .2rem;
    background-color: $mainColor;
    box-sizing: border-box;
    &:active{
	    background-color: #9f151e;
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/basic/searchBlock/searchBlock.vue